import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import RobitoLogo from "../components/AppLogo";
import { apiPostAuth } from "../utils/api"; // ⬅️ use your auth wrapper

/** Utility: currency formatting (adjust currency/locale as you wish) */
const CURRENCY = "IDR";
const LOCALE = "id-ID";
const fmt = (n) =>
  new Intl.NumberFormat(LOCALE, {
    style: "currency",
    currency: CURRENCY,
    maximumFractionDigits: 0,
  }).format(n);

/**
 * Pricing options
 */
const PRICING_OPTIONS = [
  {
    id: "1",
    packageName: "Starter",
    durationMonths: 3,
    monthlyPrice: 33_300,
    fullPrice: 100_000,
    price: 100_000,
  },
  {
    id: "2",
    packageName: "Growth",
    durationMonths: 6,
    monthlyPrice: 30_000,
    fullPrice: 200_000,
    price: 180_000,
  },
  {
    id: "3",
    packageName: "Enterprise",
    durationMonths: 12,
    monthlyPrice: 20_000,
    fullPrice: 400_000,
    price: 240_000,
  },
];

function TopBar() {
  const navigate = useNavigate();
  return (
    <header className="header">
      <div className="left">
        <button
          className="icon-btn"
          onClick={() => navigate(-1)}
          aria-label="Back"
          title="Back"
          style={{ color: "white" }}
        >
          ‹
        </button>
      </div>
      <div className="logo">
        <RobitoLogo />
      </div>
      <div className="right" />
    </header>
  );
}

export default function Create() {
  const [selectedId, setSelectedId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [failMsg, setFailMsg] = useState("");

  const selected = useMemo(
    () => PRICING_OPTIONS.find((p) => p.id === selectedId) || null,
    [selectedId]
  );

  const requestPaymentLink = async () => {
    if (!selected || loading) return;
    setLoading(true);
    setFailMsg("");

    try {
      // Adjust payload keys to what your backend expects
      const payload = {
        product_id: selected.id,
      };

      const response = await apiPostAuth("/checkout/payment.php", payload);

      if (response?.result === 1) {
        const link = response?.data?.payment_url || response?.payment_url;
        if (link) {
          // Replace current page so user can't go back to Create
          window.location.replace(link);
          return;
        } else {
          setFailMsg("Payment link tidak ditemukan dari server.");
        }
      } else {
        setFailMsg(response?.message || "Gagal membuat pembayaran.");
      }
    } catch (error) {
      setFailMsg("Tidak dapat memproses pembayaran saat ini.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="app-shell">
      <TopBar />
      <main className="main">
        <h2 style={{ margin: "0 0 8px" }}>Choose your plan</h2>
        <p className="small" style={{ marginTop: 0 }}>
          Pilih durasi langganan yang cocok. Kamu bisa upgrade kapan saja.
        </p>

        <div className="pricing-grid" role="list" aria-busy={loading ? "true" : "false"}>
          {PRICING_OPTIONS.map((plan) => {
            const isActive = selectedId === plan.id;
            var savings = plan.fullPrice > plan.price ? plan.fullPrice - plan.price : 0;
            if(plan.id === "1"){
                savings = 0;
            }

            return (
              <button
                key={plan.id}
                type="button"
                className={`plan-card ${isActive ? "selected" : ""}`}
                onClick={() => !loading && setSelectedId(plan.id)}
                aria-pressed={isActive}
                disabled={loading}
              >
                <div className="plan-head">
                  <div className="pkg">{plan.packageName}</div>
                  <div className="badge">{plan.durationMonths} bulan</div>
                </div>

                <div className="price-row">
                  <div className="final-price">{fmt(plan.price)}</div>
                  <div className="per"> / {plan.durationMonths} bln</div>
                </div>

                <div className="muted-line">
                  Bulanan: <strong>{fmt(plan.monthlyPrice)}</strong>
                </div>
                {savings > 0 && <div className="save">Hemat {fmt(savings)}</div>}
              </button>
            );
          })}
        </div>

        <div className="summary-card">
          {selected ? (
            <>
              <div className="summary-row">
                <span>Paket</span>
                <strong>
                  {selected.packageName} · {selected.durationMonths} bln
                </strong>
              </div>
              <div className="summary-row">
                <span>Harga</span>
                <strong>{fmt(selected.price)}</strong>
              </div>

              {failMsg && (
                <div className="small" style={{ color: "#ffb3b3", marginTop: 8 }}>
                  {failMsg}
                </div>
              )}

              <button
                className="btn block pay-cta"
                onClick={requestPaymentLink}
                style={{ marginTop: 12 }}
                disabled={!selected || loading}
              >
                {loading ? "Memproses..." : "Lanjutkan ke Pembayaran"}
              </button>
            </>
          ) : (
            <div className="small" style={{ textAlign: "center" }}>
              Pilih paket terlebih dahulu untuk melanjutkan.
            </div>
          )}
        </div>
      </main>
    </div>
  );
}
